import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  module: undefined,
  // dashboard
  dashboardAnnouncements: [],
  dashboardMyTasks: [],
  dashboardUpcomingEvents: [],
  // modules
  notifications: [],
  permittedModules: null,
  myTimes: [],
  myTime: null,
  userManagement: [],
  roleGroup: [],
  roleGroupAssociation: [],
  roles: [],
  applicationList: [],
  applicationContractList: [],
  userAssociatedRoleGroups: [],
  searchedRoleGroups: [],
  associatedRoles: [],
  associationTypes: [],
  employeeAssociations: [],
  searchedUserList: [],
  /**
   * @type {{processName: string, processDesc: string, isActive: number}[]}
   */
  processTypes: [],
  /**
   * @type {{dName: string, iName: string, wfDefId: string}[]}
   */
  workflows: [],
  /**
   * @type {subAction: string, subActionId: number}
   */
  actions: [],
  processAssociations: [],
  userGroups: [],
  usersInUserGroup: [],
  availableStatus: [],
  statusConfiguration: [],
  userGroupAssociation: [],
  approvalGroups: [],
  usersInApprovalGroup: [],
  associatedUserGroupsWithApprovalGroup: [],
  availableNextStatus: []
};

export default {
  actions,
  mutations,
  getters,
  state,
  namespaced: true
};
